import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { FC } from 'react';
import { LoadingButton } from '@mui/lab';

interface IConfirmationModalProps {
  loading?: boolean;
  children?: React.ReactNode;
  onCancel: () => void;
  onSuccess: () => void;
}

export const ConfirmationModal: FC<IConfirmationModalProps> = (props) => {
  return (
    <Dialog
      open={true}
      maxWidth={'xs'}
      fullWidth={true}
      onClose={props.onCancel}
      aria-labelledby="alert-dialog"
      aria-describedby="alert-description"
    >
      <DialogTitle id="alert-dialog">Confirmación requerida</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-description" component={'div'}>
          {props.children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          disabled={props.loading}
          disableElevation={true}
          onClick={props.onCancel}
        >
          Cancelar
        </Button>
        <LoadingButton
          autoFocus
          loading={props.loading}
          color="primary"
          variant="contained"
          disableElevation={true}
          onClick={props.onSuccess}
        >
          Aceptar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
